/* template */
<template><div class="card-history-wrap"><div class="card-history-header-wrap"><div class="card-history-title-wrap"><title-bar bg-color="rgba(0,0,0,0)" icon-color="#ffffff" title-color="#ffffff" title="省钱卡购买历史" :is-show-right-set="(false)" :isHideNav="(isHideNav)" @backClick="onBackClick" class="card-history-title"/></div></div><div :class='("card-history-list-wrap "+(isMiniProgram ? "mp-card-history-list" : ""))'><delete-order v-for="(item, listIndex) in (cardList)" :key="item['{{ listIndex }}']" @deleteOrder="deleteOrder" :cardData="(item)" class="order-history-box"><pay-card-record slot="content-slot" :cardData="(item)" :cityId="(cityId)" :returnUserInfo="(returnUserInfo)" class="history-box"></pay-card-record><div slot="delete-slot" class="delete-btn" v-if="(item.status === EnumCardType.Overdue || item.status === EnumCardType.Refunded || item.status === EnumCardType.AssistFailRefunded)">删除</div></delete-order><div class="card-history-footer-wrap"><div class="card-history-footer-text">仅展示一年内购买记录</div></div></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m4c6f7547"}'>
.card-history-wrap
  overflow hidden
  min-height 100vh
  position relative
  background-image linear-gradient(180deg, #FFD8C7 23%, rgba(255,221,154,0.20) 56%, rgba(255,222,143,0.00) 87%)
  .card-history-header-wrap
    position absolute
    z-index 0
    width 750rpx
    height 322rpx
    background-image url('https://ut-static.udache.com/webx/fe-agility-wyc/0W_XIRvL73EgikA_rLkmd.png')
    background-repeat: no-repeat
    background-size 100% 100%
    .card-history-title-wrap
      margin-top 30rpx
      .card-history-title
        text-align center
        font-size 36rpx
        color #fff
        text-align center
        text-shadow 0 14rpx 13rpx rgba(246,53,53,0.50)
        font-weight 600
  .card-history-list-wrap
    width 100%
    height calc(100vh - 180rpx)
    margin-top 180rpx
    padding-top 73rpx
    overflow-y auto
    position relative
    &.mp-card-history-list
      margin-top 0
    .order-history-box
      width 100%
      margin 0 auto 34rpx auto
      .delete-btn
        margin-left 18rpx
        width 113rpx
        height 210rpx
        background #DB382D
        border-radius 13rpx 0 0 13rpx
        font-size: 22rpx;
        color #FFFFFF
        letter-spacing 0
        font-weight 400
        text-align center
        line-height 210rpx
    .card-history-footer-wrap
      width 100%
      display flex
      justify-content center
      margin-bottom 158rpx
      margin-top 100rpx
      .card-history-footer-text
        position relative
        padding 0rpx 17rpx
        text-align center
        opacity 0.56
        font-size 24rpx
        color #666666
        letter-spacing 0
        text-align center
        font-weight 400
        &::before, &::after
          content ''
          display block
          width 144rpx
          opacity 0.35
          border 1px solid #979797
          position absolute
        &::before
          left -149rpx
          top 16rpx
        &::after
          right -149rpx
          bottom 16rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import mpx, { createPage } from '@mpxjs/core'
import { deleteCardOrder, getCardOrderList } from '../../api'
import { GlobalEnv } from '@/lib/webx'
import { track } from '../../lib/webx/mpx/mixins/pay_card/track'
import { EnumCardType } from '@/lib/webx/defines'
import { hideNativeBar, setTitle, throttle } from '../../lib/js/util'
import { is } from '@didi/webx-js'
import { initEnv } from '../../lib/webx/global_env'

createPage({
  data() {
    return {
      // 省钱卡购买历史记录列表
      cardList: null,
      EnumCardType,
      pageShow: false,
      isMiniProgram: is('miniprogram'),
      listCurPage: 1,
      listTotalPage: 1,
      requestFlag: false,
      currentKey: 8, // 当前页面list展示的末尾下标值
      maxShoeListSize: 8, // 分页size
      listTotalRecords: 1,
      allCards: [],
      returnUserInfo: {},
    }
  },
  computed: {
    cityId() {
      return GlobalEnv.locationInfo.cityId
    },
    isHideNav() {
      return hideNativeBar()
    },
  },
  async onLoad(){
    window.PerfTrack?.jsReady?.()
    await initEnv({
      needLocation: true,
      needLogin: true,
      removeCacheEnv: true,
      back_url: window.location.href,
      forbidGetApollo: true,
    })
    await this.getHistoryList()
    setTitle('省钱卡购买历史')
    // 省钱卡购买历史记录曝光埋点
    track('wyc_ckh5_trippackage_list_card_buyhistory_sw', '省钱卡购买记录页曝光')
  },
  async onShow() {
    await initEnv({
      needLocation: true,
      needLogin: true,
      removeCacheEnv: true,
      back_url: window.location.href,
      forbidGetApollo: true,
    })
    await this.getHistoryList()
  },
  onReady() {
    const container = document.querySelector('.card-history-list-wrap')
    container && container.addEventListener('scroll', e => {
      if ((e.target.clientHeight + e.target.scrollTop) >= e.target.scrollHeight - 10) {
        setTimeout(() => {
          this.getMore()
        }, 1000)
      }
    })
  },
  methods: {
    onBackClick() {
      mpx.navigateBack()
    },
    async getHistoryList(page = 1, reset = true) {
      if (this.requestFlag) {
        return
      }
      this.requestFlag = true
      this.pageShow = false
      mpx.showLoading({
        title: '', // 提示的内容,
        mask: true, // 显示透明蒙层，防止触摸穿透,
        success: res => {},
      })
      try {
        const { errno, data, login_user } = await getCardOrderList({
          token: GlobalEnv.loginInfo.token,
          city_id: this.cityId,
          lat: GlobalEnv.locationInfo.lat,
          lng: GlobalEnv.locationInfo.lng,
          page,
          size: 100,
        })
        if (errno === 0) {
          // let cardLlistData = this.cardList
          // const dataList = data?.list || []
          // if (reset) {
          //   cardLlistData = dataList
          // } else {
          //   cardLlistData.push(...dataList)
          // }
          // this.cardList = cardLlistData
          // this.listCurPage = data.pagination.current_page
          // this.listTotalPage =  data.pagination.total_pages
          // console.log('login_user===', login_user)
          this.allCards = data?.list
          this.cardList = data?.list.length > this.maxShoeListSize ? data?.list.slice(0, this.currentKey) : data?.list
          this.listTotalRecords =  data.pagination.total_records
          // console.log('cardList',this.cardList)
          this.returnUserInfo = login_user
        }
        this.pageShow = true
        this.requestFlag = false
        mpx.hideLoading()
        document.getElementById('loading') && (document.getElementById('loading').style.display = 'none')

      } catch (err) {
        mpx.hideLoading()
        document.getElementById('loading') && (document.getElementById('loading').style.display = 'none')
        this.pageShow = true
        this.requestFlag = false
      }
    },
    deleteOrder(e) {
      deleteCardOrder({
        token: GlobalEnv.loginInfo.token,
        order_id: e.detail?.order_id,
      }).then(res => {
        this.getHistoryList()
      }).catch(err => {
        console.log('deleteCardOrder===err', err)
      })
    },
    getMore: throttle(function() {
      // if (this.listCurPage < this.listTotalPage) {
      //   this.getHistoryList(this.listCurPage + 1, false)
      // }
      if (this.listTotalRecords > this.currentKey) {
        const card = this.allCards.slice(this.currentKey, this.currentKey + this.maxShoeListSize)
        this.cardList.push(...card)
        this.currentKey = this.currentKey + this.maxShoeListSize
      }
    }, 500),
  },
  ready() {
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {"backgroundColor":"#ffffff"},
    // @ts-ignore
    {},
    // @ts-ignore
    {'delete-order':getComponent(require("../../components/common/delete-order.mpx?component=true&componentId=delete-order66af43a9")),'pay-card-record':getComponent(require("../../components/pay_card_mall/pay-card-record.mpx?component=true&componentId=pay-card-record3e0032df")),'loading':getComponent(require("../../components/pay_card_mall/loading.mpx?component=true&componentId=loading29b01cdc")),'title-bar':getComponent(require("../../../node_modules/@didi/wyc-components/src/components/title-bar/index.mpx?component=true&componentId=index461bd906"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
